module.exports = __webpack_public_path__ + "img/star_4_5.df7b4335.png";